import React from 'react';
import { Navigate } from 'react-router-dom';

// Legacy route handler: we removed the old single profile setup UI.
// Singles manage their resume + references under /my-resumes now.
const SingleLegacyRedirect = () => {
  return <Navigate to="/my-resumes" replace />;
};

export default SingleLegacyRedirect;


